import { useState, useMemo, useEffect, useRef } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import dayjs from "dayjs";

import { whitedelete } from "../utils/svgs/svgcode";
import { drag } from "./svg";
import { faxDocumentUrl, faxErrorMessage, refreshFaxes, releaseFaxDocumentUrl } from "./faxApi";
import SendToEmrDocument from "./modals/sendtoemr";
import SendToAthena from "./modals/sendtoathena";
import { useSelector } from "react-redux";
import RefreshIcon from '@mui/icons-material/Refresh';
import ToastMessage from "../utils/mui/righttoptoast";
import { faxLine, practiceFaxProfile } from "../config/practice";
import { faxFilingAccess } from "./faxFilingAccess";
import {
  FAX_AI_AWAIT_POLL_MAX,
  FAX_AI_POLL_MAX,
  FAX_AI_POLL_MS,
  faxAiAwaiting,
  faxAiAwaitingKey,
  faxAiPendingKey,
} from "./faxAi";
import { FaxAiListLine, FaxAiViewerLine, FaxSourceHeader, FaxSourceSubLine, faxOwnNames } from "./faxAiParts";
import { faxSource } from "./faxAi";
import {
  ALL_USERS,
  FAX_DELETE_REASONS,
  FAX_DONE_PICKS,
  faxDeleteReasonLabel,
  faxIsDeleted,
  faxJunkHint,
  filterFaxRows,
  loadFaxFilters,
  resetSavedAssignedMeOnce,
  saveFaxFilters,
} from "./faxWork";
import { FaxActiveFilterChips, FaxJunkLine, FaxWorkFilters, FaxWorkListLine, FaxWorkPanel } from "./faxWorkParts";
import InboxFaxFilters from "../inbox/InboxFaxFilters";
import InboxFaxListItem from "../inbox/InboxFaxListItem";
import { deleteFax, faxAssignMany, faxWorkAct } from "./faxApi";
import { faxUserName } from "./faxWork";
import { eventBus } from "../utils/eventBus";
import FaxPdfViewer from "./FaxPdfViewer";
const statusChip = (rawStatus, { active = false } = {}) => {
  const code = (rawStatus || "").toUpperCase().trim();

  const map = {
    READ: {
      label: "Read",
      cls: "text-[#232323] bg-[#FFFFFF] border border-[#E5E7EB]",
    },
    UNREAD: {
      label: "Unread",
      cls: "text-[#E17954] bg-[#FFF5F5] border border-[#E17954]",
    },
  };

  const s = map[code] || { label: "—", cls: "text-[#667085] bg-[#E7E9F0]" };

  const activeCls = active
    ? "bg-[#FFFFFF1A] text-white border border-white/40"
    : "";

  return (
    <span
      className={`px-3 py-[3px] rounded-full text-xs font-medium ${s.cls} ${activeCls}`}
    >
      {s.label}
    </span>
  );
};

// The server's message of a refused call, else `fallback`.
const faxErrorMessageText = (error, fallback) => {
  const m = error?.response?.data?.message;
  return typeof m === "string" && m ? m : error?.fax && error.message ? error.message : fallback;
};

const FaxTable = ({
  loading,
  fax,
  fetchFax,
  faxProviders = [],
  workAvailable = false,
  deletedFax = [],
  deletedDays = 7,
  deletedLoaded = false,
  fetchDeletedFax,
  // "All (30 days)" (owner 10-22): v2 GET fax/all rows (provider-filtered on
  // the server) and the window's per-provider counts (fax.jsx)
  all30Fax = [],
  all30Counts = null,
  all30Loaded = false,
  fetchAll30Fax,
  // assignee (owner 10-13 "user buckets"): {available, staff, canAssign, me}
  assign = null,
  // The unified Inbox (src/inbox/InboxPage.jsx): its organised filter bar
  // (src/inbox/InboxFaxFilters.jsx; `inboxToolbar` = search / day / Send Fax
  // from fax.jsx). Without it (Communication > Fax, OSA): as before.
  inboxStyle = false,
  inboxToolbar = null,
}) => {
  const assignOn = Boolean(workAvailable && assign && assign.available);
  const staff = (assign && assign.staff) || [];
  const me = assign ? assign.me ?? null : null;
  const canAssign = Boolean(assignOn && assign.canAssign);
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
const [openMenuId, setOpenMenuId] = useState(null);
const menuRef = useRef(null);
  // Selection and detail states
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFaxId, setSelectedFaxId] = useState(null);
  const [selectedFax, setSelectedFax] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  // why (FAX_DELETE_REASONS id, "" = not given)
  const [deleteReason, setDeleteReason] = useState("");
  // the "Mark Done instead?" prompt before a delete ({items}), its quick pick
  // for a batch, and the rows a bulk delete removes (null = one fax)
  const [doneNudge, setDoneNudge] = useState(null);
  const [nudgePick, setNudgePick] = useState("");
  const [nudgeSaving, setNudgeSaving] = useState(false);
  const [bulkDelete, setBulkDelete] = useState(null);
  const [documentUrl, setDocumentUrl] = useState();
  const [documentError, setDocumentError] = useState("");
  // The object URL on screen (released when replaced or on unmount) and the
  // latest load: a slower answer for an earlier click is dropped, so the
  // viewer never shows another fax than the one selected.
  const documentUrlRef = useRef(null);
  const documentLoadRef = useRef(0);
const [iscollapse,setIsCollapse]=useState(!false)
const[emrModal,setEmrModal]=useState(false)
 const taskscreenprev = useSelector((state) => state.userPrivileges.taskrpm);
const[athenaModal,setAthenaModal]=useState(false)
// The practice's fax setup (config/practice.js FAX_PROFILES).
const faxProfile = practiceFaxProfile() || {};
// This practice's own names: never shown as the sender of a fax (faxAiParts.jsx).
const ownNames = useMemo(() => faxOwnNames(), []);
// Filing buttons (faxFilingAccess.js): Send to EMR (care timeline + review task;
// its "Send to Athena" box needs "send to athena") where the profile turns it on -
// for everyone, or on 9928 (owner 10-16) only for users with "send to emr";
// otherwise Send to Athena with "send to athena". On 9928 a user with both sees
// both buttons, and a user with neither sees a line naming both permissions.
const { canSendToAthena, showEmr, showAthenaButton, hint: filingHint } = faxFilingAccess(faxProfile, taskscreenprev);
const [currentIndex, setCurrentIndex] = useState(0);
 const handleToastClose = () => {
    setOpenToast(false);
  };
       const [toastSeverity, setToastSeverity] = useState('success');
   const [openToast, setOpenToast] = useState(false);
      const [toastMessage, setToastMessage] = useState('');
  // Fax work quick filters (faxWork.js, owner 10-11): To work / Done / Review /
  // All and one provider, remembered per user; applied after fax.jsx's search
  // and date filter. Without work tracking on the server the list is as before.
  const workUser = useSelector((state) => state.userconfig?.username) || "";
  // Inbox (owner 10-22): a remembered "Assigned: me" is reset once per user
  // on the first Inbox load (faxWork.js resetSavedAssignedMeOnce).
  const [workFilters, setWorkFilters] = useState(() => {
    const loaded = loadFaxFilters(workUser);
    if (inboxStyle && resetSavedAssignedMeOnce(workUser)) return { ...loaded, user: ALL_USERS };
    return loaded;
  });
  const changeWorkFilters = (next) => {
    setWorkFilters(next);
    saveFaxFilters(workUser, next);
    setCurrentPage(1);
  };
  // After a filing: the viewer opens "Mark done" with the matching pick.
  const [workRequest, setWorkRequest] = useState(null);
  // The Deleted view lists v2 GET fax/deleted (fax.jsx reads it when opened).
  const inDeletedView = workAvailable && workFilters.status === "deleted";
  // All (30 days): open + done + deleted from v2 GET fax/all (owner 10-22)
  const inAll30View = workAvailable && workFilters.status === "all30";
  // without assignee tracking the "User" chips are off: the provider row applies;
  // the Deleted view narrows by provider only
  const effectiveFilters = useMemo(
    () =>
      inboxStyle
        ? { ...workFilters, combine: true, ...(assignOn ? {} : { user: "all" }) }
        : assignOn && workFilters.status !== "deleted"
          ? workFilters
          : { ...workFilters, by: "provider" },
    [workFilters, assignOn, inboxStyle]
  );
  // the rows of the current view before the provider / user picks
  const viewRows = inDeletedView ? deletedFax : inAll30View ? all30Fax : fax;
  const shown = useMemo(
    () => (workAvailable ? filterFaxRows(viewRows, effectiveFilters, undefined, me) : fax || []),
    [fax, viewRows, effectiveFilters, workAvailable, me]
  );
  // the provider v2 GET fax/all narrows to ("all" when the User chips apply)
  const all30Provider = inboxStyle || effectiveFilters.by !== "user" ? workFilters.provider || "all" : "all";
  // Bulk assign (owner 10-13): select several -> Assign to. Ids of faxes
  // (row ids), cleared when the view changes.
  const [picked, setPicked] = useState(() => new Set());
  const bulkOn = canAssign && !inDeletedView;
  // the picked faxes still in the list (a deleted row of All (30 days) is skipped)
  const pickedLive = () => shown.filter((r) => picked.has(r.id) && !faxIsDeleted(r));
  useEffect(() => {
    setPicked(new Set());
  }, [workFilters.status, workFilters.by, workFilters.user, workFilters.provider]);
  const togglePick = (id) =>
    setPicked((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  const [bulkSaving, setBulkSaving] = useState(false);
  const bulkAssign = async (value) => {
    const rows = shown.filter((r) => picked.has(r.id));
    if (!rows.length || value === "") return;
    setBulkSaving(true);
    try {
      const res = await faxAssignMany(rows, value === "none" ? null : value);
      const skipped = Array.isArray(res?.skipped) ? res.skipped.length : 0;
      const n = Number(res?.updated) || 0;
      setToastMessage(
        `${n} ${n === 1 ? "fax" : "faxes"} ${value === "none" ? "unassigned" : `assigned to ${faxUserName(staff, value)}`}` +
          (skipped ? ` (${skipped} skipped)` : "")
      );
      setToastSeverity("success");
      setPicked(new Set());
      reloadLists();
      eventBus.emit("fax:assigned-changed");
    } catch (e) {
      setToastMessage(faxErrorMessageText(e, "Could not assign the faxes"));
      setToastSeverity("error");
    } finally {
      setOpenToast(true);
      setBulkSaving(false);
    }
  };
  const fetchDeletedRef = useRef(fetchDeletedFax);
  fetchDeletedRef.current = fetchDeletedFax;
  useEffect(() => {
    if (inDeletedView && typeof fetchDeletedRef.current === "function") fetchDeletedRef.current(deletedDays);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inDeletedView]);
  const fetchAll30Ref = useRef(fetchAll30Fax);
  fetchAll30Ref.current = fetchAll30Fax;
  useEffect(() => {
    if (inAll30View && typeof fetchAll30Ref.current === "function") fetchAll30Ref.current(all30Provider);
  }, [inAll30View, all30Provider]);
  // After a delete / restore / work change: the list, and the Deleted / All
  // (30 days) views when they were read.
  const reloadLists = () => {
    if (typeof fetchFax === "function") fetchFax(true);
    if ((deletedLoaded || inDeletedView) && typeof fetchDeletedFax === "function") fetchDeletedFax(deletedDays, true);
    if ((all30Loaded || inAll30View) && typeof fetchAll30Fax === "function") fetchAll30Fax(all30Provider, true);
  };

  const totalPages = Math.ceil((shown.length || 0) / itemsPerPage);
  const paginatedData = useMemo(
    () => shown.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage),
    [shown, currentPage, itemsPerPage]
  );

  // The selected fax as the list has it now (a re-read may have brought its
  // AI read), else the row as it was when clicked.
  const viewedFax =
    (selectedFaxId !== null &&
      (viewRows?.find((f) => f.id === selectedFaxId) ||
        fax?.find((f) => f.id === selectedFaxId) ||
        deletedFax?.find((f) => f.id === selectedFaxId) ||
        all30Fax?.find((f) => f.id === selectedFaxId))) ||
    selectedFax;
  const viewedDeleted = faxIsDeleted(viewedFax);
  const viewedJunk = viewedFax && !viewedDeleted ? faxJunkHint(viewedFax) : null;

  // While a listed fax is still being summarized, re-read the list once a
  // minute so its label shows without a reload: at most FAX_AI_POLL_MAX times
  // for the same pending faxes, silently (fax.jsx keeps the list if a re-read
  // fails), and never when nothing is pending or the server has no AI step.
  // Also while a recent fax has no read yet (faxAi.js faxAiAwaiting; only
  // for a profile with aiLabels): at most FAX_AI_AWAIT_POLL_MAX times for the
  // same set, counted again when one of them is opened (10-08: the 9928 job
  // starts after the list that triggers it, so that list never had labels).
  const fetchFaxRef = useRef(fetchFax);
  fetchFaxRef.current = fetchFax;
  const faxAiPending = useMemo(() => faxAiPendingKey(fax), [fax]);
  const faxAiAwaitKey = useMemo(() => (faxProfile.aiLabels ? faxAiAwaitingKey(fax) : ""), [fax, faxProfile.aiLabels]);
  const openedAwaiting =
    faxProfile.aiLabels && viewedFax && faxAiAwaiting(viewedFax) ? String(viewedFax.faxid ?? viewedFax.id) : "";
  const faxAiPollKey = faxAiPending || faxAiAwaitKey ? `${faxAiPending}|${faxAiAwaitKey}|${openedAwaiting}` : "";
  const faxAiPollMax = faxAiAwaitKey ? FAX_AI_AWAIT_POLL_MAX : FAX_AI_POLL_MAX;
  useEffect(() => {
    if (!faxAiPollKey) return undefined;
    let polls = 0;
    const timer = setInterval(() => {
      polls += 1;
      if (polls >= faxAiPollMax) clearInterval(timer);
      if (typeof fetchFaxRef.current === "function") fetchFaxRef.current(true);
    }, FAX_AI_POLL_MS);
    return () => clearInterval(timer);
  }, [faxAiPollKey, faxAiPollMax]);


useEffect(() => {
  function handleClickOutside(e) {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpenMenuId(null);
    }
  }

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

  // Handlers
  // const handlePrev = () => currentPage > 1 && setCurrentPage((p) => p - 1);
  // const handleNext = () =>
  //   currentPage < totalPages && setCurrentPage((p) => p + 1);

  const handlePrev = () => {
  if (currentPage > 1) {
    setCurrentPage((prevPage) => prevPage - 1);
  }
};
const handleNext = () => {
  if (currentPage < totalPages) {
    setCurrentPage((prevPage) => prevPage + 1);
  }
};

const handleRowPrev = () => {
  // const currentIndex = paginatedData.findIndex(item => item.id === selectedFaxId);
  // if (currentIndex > 0) {
  //   const prevFaxItem = paginatedData[currentIndex - 1];
  //   selectFax(prevFaxItem); // Select the previous row
  // }
  const currentIndex = shown.findIndex(item => item.id === selectedFaxId);
  if (currentIndex > 0) {
    const prevFaxItem = shown[currentIndex - 1];
    selectFax(prevFaxItem);
    
    // Optionally, adjust page if we move to the previous page (e.g., if the row is from a previous page)
    if (currentIndex % itemsPerPage === 0) {
      setCurrentPage(prevPage => prevPage - 1); // Move to previous page if we're at the start of a page
    }
  }else{
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  }
};

const handleRowNext = () => {
  // const currentIndex = paginatedData.findIndex(item => item.id === selectedFaxId);
  // if (currentIndex < paginatedData.length - 1) {
  //   const nextFaxItem = paginatedData[currentIndex + 1];
  //   selectFax(nextFaxItem); // Select the next row
  // }
  const currentIndex = shown.findIndex(item => item.id === selectedFaxId);
  if (currentIndex < shown.length - 1) {
    const nextFaxItem = shown[currentIndex + 1];
    selectFax(nextFaxItem);

    // Optionally, adjust page if we move to the next page (e.g., if the row is from the next page)
    if ((currentIndex + 1) % itemsPerPage === 0) {
      setCurrentPage(prevPage => prevPage + 1); // Move to next page if we're at the end of a page
    }
  }else{
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  }
};

  const handlePerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const selectFax = (faxItem) => {
    setWorkRequest(null);
    setSelectedFaxId(faxItem.id);
    setSelectedFax(faxItem);
    viewAttachment(faxItem);
  };

  const showDocument = (url) => {
    releaseFaxDocumentUrl(documentUrlRef.current);
    documentUrlRef.current = url || null;
    setDocumentUrl(url || undefined);
  };

  useEffect(
    () => () => {
      documentLoadRef.current += 1;
      releaseFaxDocumentUrl(documentUrlRef.current);
      documentUrlRef.current = null;
    },
    []
  );

  // The PDF comes from the v2 document route with the staff token (faxApi.js),
  // never from a hub URL.
  const viewAttachment = async (item) => {
    const load = ++documentLoadRef.current;
    showDocument(null);
    setDocumentError("");
    setIsLoading(true);

    try {
      const url = await faxDocumentUrl(item);
      if (load !== documentLoadRef.current) {
        releaseFaxDocumentUrl(url);
        return;
      }
      showDocument(url);
    } catch (error) {
      console.log(error);
      const message = await faxErrorMessage(error);
      if (load === documentLoadRef.current) setDocumentError(message);
    } finally {
      if (load === documentLoadRef.current) setIsLoading(false);
    }
  };

  const openDeleteModal = (item) => {
    setSelectedFax(item);
    // a fax the AI reads as spam opens with "Spam" picked (staff can change it)
    const hint = faxJunkHint(item);
    setDeleteReason(hint ? (hint.kind === "wrong_recipient" ? "not_ours" : "spam") : "");
    setDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
    setBulkDelete(null);
    setSelectedFax(null);
  };

  // Owner 10-22: Delete on a fax that is not spam/junk first offers Mark
  // Done, which keeps it findable (Done + its provider); a deleted fax only
  // shows under Deleted / All (30 days). `doneNudge` = {items: [rows]}; one
  // prompt for a bulk delete. Delete as spam (marked spam) skips it.
  const needsNudge = (item) => workAvailable && !faxIsDeleted(item) && !faxJunkHint(item);
  const requestDelete = (item) => {
    if (!item) return;
    if (needsNudge(item)) {
      setNudgePick("");
      setDoneNudge({ items: [item] });
    } else openDeleteModal(item);
  };
  const openBulkDeleteModal = (rows) => {
    setBulkDelete(rows);
    setDeleteReason(rows.every((r) => faxJunkHint(r)) ? "spam" : "");
    setDeleteModalOpen(true);
  };
  const requestBulkDelete = () => {
    const rows = pickedLive();
    if (!rows.length) return;
    if (rows.some(needsNudge)) {
      setNudgePick("");
      setDoneNudge({ items: rows });
    } else openBulkDeleteModal(rows);
  };
  const nudgeDeleteAnyway = () => {
    const items = doneNudge?.items || [];
    setDoneNudge(null);
    if (items.length === 1) openDeleteModal(items[0]);
    else if (items.length > 1) openBulkDeleteModal(items);
  };
  const nudgeMarkDone = async () => {
    const items = doneNudge?.items || [];
    if (items.length === 1) {
      // one fax: open it with "Mark done" (the viewer asks what happened)
      setDoneNudge(null);
      const item = items[0];
      if (selectedFaxId !== item.id) selectFax(item);
      setWorkRequest({ mode: "done", pick: "", nonce: Date.now() });
      return;
    }
    if (!nudgePick) return;
    setNudgeSaving(true);
    let ok = 0;
    let failed = 0;
    for (const r of items) {
      try {
        await faxWorkAct(r, { action: "done", quickPick: nudgePick });
        ok += 1;
      } catch (e) {
        failed += 1;
      }
    }
    setNudgeSaving(false);
    setDoneNudge(null);
    setPicked(new Set());
    setToastMessage(`${ok} ${ok === 1 ? "fax" : "faxes"} marked done` + (failed ? ` (${failed} not saved)` : ""));
    setToastSeverity(failed ? "warning" : "success");
    setOpenToast(true);
    reloadLists();
  };
// "Check for new faxes" (profile.refresh, 7825): v2 POST /v1/{pid}/fax/refresh
// with the staff token (faxApi.js). The server also runs it on a timer. 9928's
// inbound comes from the hub cron; it has no button (as before).
const handleRefresh = async () => {
  try {
    setIsLoading(true);
    const res = await refreshFaxes();
    const inserted = Number(res?.inserted) || 0;
    const failed = Number(res?.download_failed) || 0;
    setToastMessage(
      `${inserted} new ${inserted === 1 ? "fax" : "faxes"}` + (failed > 0 ? `, ${failed} not downloaded yet` : "")
    );
    setToastSeverity(failed > 0 ? "warning" : "success");
    setOpenToast(true);
  } catch (error) {
    console.log(error);
    const message = error?.response?.data?.message;
    setToastMessage(typeof message === "string" && message ? message : "Fax refresh failed");
    setToastSeverity("error");
    setOpenToast(true);
  } finally {
    setIsLoading(false);
    fetchFax(true);
  }
};


  // Filing from Send to EMR / Send to Athena: an automatic work-log entry (and
  // the chart, so the provider follows it), then "Mark done" with the pick.
  // Send to Athena by page groups (10-13) logs one entry per filed document
  // (note: "<title> (pages a–b)", openDone false) and then asks for "Mark
  // done" once ({doneOnly: true}).
  const handleFiled = (faxItem, { action, patientId, athena, note, openDone = true, doneOnly = false } = {}) => {
    if (!workAvailable || !faxItem) return;
    if (!doneOnly) {
      faxWorkAct(faxItem, { action, patientId, note })
        .then(() => fetchFax(true))
        .catch((e) => console.warn("fax work log not written", e));
    }
    if (doneOnly || openDone) {
      setWorkRequest({ mode: "done", pick: athena ? "Sent to Athena" : "Filed to chart", nonce: Date.now() });
    }
  };

  const [deleteNote, setDeleteNote] = useState("");

  // Delete (owner 10-12: staff may delete spam / faxes not for us; we keep
  // track): v2 logs who / when / reason / note with the delete itself; an
  // older v2 that does not (work_logged !== true) gets the entry from here.
  // The fax then shows under Deleted, where it can be restored.
  const removeFax = async (item, { reason = "", note = "" } = {}) => {
    const res = await deleteFax(item, { reason, note });
    if (workAvailable && res?.work_logged !== true) {
      await faxWorkAct(item, { action: "deleted", note, quickPick: faxDeleteReasonLabel(reason) || undefined }).catch((e) =>
        console.warn("fax work log not written", e)
      );
    }
    if (selectedFaxId === item.id) {
      setSelectedFaxId(null);
      setSelectedFax(null);
      documentLoadRef.current += 1;
      showDocument(null);
    }
    reloadLists();
    return res;
  };

  const handleDelete = async () => {
    if (bulkDelete && bulkDelete.length) {
      const rows = bulkDelete;
      const note = deleteNote.trim();
      const reason = deleteReason;
      setIsLoading(true);
      let ok = 0;
      let failed = 0;
      for (const r of rows) {
        try {
          await removeFax(r, { reason, note });
          ok += 1;
        } catch (e) {
          failed += 1;
        }
      }
      setIsLoading(false);
      setDeleteNote("");
      setDeleteReason("");
      setPicked(new Set());
      closeDeleteModal();
      setToastMessage(`${ok} ${ok === 1 ? "fax" : "faxes"} deleted` + (failed ? ` (${failed} not deleted)` : ""));
      setToastSeverity(failed ? "warning" : "success");
      setOpenToast(true);
      return;
    }
    if (!selectedFax) return;
    const deleted = selectedFax;
    const note = deleteNote.trim();
    const reason = deleteReason;
    setIsLoading(true);
    try {
      await removeFax(deleted, { reason, note });
    } catch (error) {
      console.log(error);
      setToastMessage(faxErrorMessageText(error, "Could not delete the fax"));
      setToastSeverity("error");
      setOpenToast(true);
    } finally {
      setIsLoading(false);
      setDeleteNote("");
      setDeleteReason("");
      closeDeleteModal();
    }
  };

  // One click on a fax the AI reads as spam: deleted with reason "spam"
  // (logged; restorable under Deleted). Never automatic.
  const handleDeleteAsSpam = async (item) => {
    if (!item) return;
    setIsLoading(true);
    try {
      await removeFax(item, { reason: "spam" });
      setToastMessage(workAvailable ? "Deleted as spam. It is listed under Deleted." : "Deleted as spam.");
      setToastSeverity("success");
    } catch (error) {
      console.log(error);
      setToastMessage(faxErrorMessageText(error, "Could not delete the fax"));
      setToastSeverity("error");
    } finally {
      setOpenToast(true);
      setIsLoading(false);
    }
  };

  // Keep the user's page when the list refreshes — resetting to page 1 here
  // bounced the view back to FAX-1 after sending a fax to Athena (QA
  // 2026-08-19). Only clamp when the current page no longer exists.
  useEffect(() => {
    const total = Math.max(1, Math.ceil((shown.length || 0) / itemsPerPage));
    if (currentPage > total) setCurrentPage(total);
  }, [shown.length, itemsPerPage]);

  return (
    <div className="w-full rounded-xl bg-[#FFF] p-2" data-testid="fax-table">
      {/* ONE row (owner 10-13): status, Provider | User, the chips, and the
          list's two icons at the right (show/hide the list details, check
          for new faxes) — they used to sit alone on a near-empty row. */}
      {inboxStyle ? (
        <InboxFaxFilters
          rows={fax}
          viewRows={viewRows}
          serverCounts={inAll30View ? all30Counts : null}
          all30Count={all30Loaded && all30Counts ? Object.values(all30Counts).reduce((a, n) => a + (Number(n) || 0), 0) : null}
          providers={faxProviders}
          filters={effectiveFilters}
          onChange={changeWorkFilters}
          available={workAvailable}
          deletedCount={deletedFax.length}
          deletedDays={deletedDays}
          onDeletedDays={(d) => typeof fetchDeletedFax === "function" && fetchDeletedFax(d)}
          staff={staff}
          me={me}
          assignAvailable={assignOn}
          toolbar={inboxToolbar}
          actions={
            <>
              {inboxToolbar && typeof inboxToolbar.onSendFax === "function" && (
                <button
                  type="button"
                  onClick={inboxToolbar.onSendFax}
                  className="h-10 shrink-0 rounded-md border border-[#1D2951] bg-white px-4 text-[14px] font-medium text-[#1D2951] hover:bg-[#1D2951]/[0.06]"
                >
                  Send Fax
                </button>
              )}
              {faxProfile.refresh && (
                <button
                  type="button"
                  onClick={handleRefresh}
                  title="Check for new faxes"
                  aria-label="Check for new faxes"
                  className="flex h-10 w-10 items-center justify-center rounded-md border border-[#D0D5DD] bg-white text-[#667085] hover:bg-[#F2F4F7] hover:text-[#1D2951]"
                >
                  <RefreshIcon fontSize="small" />
                </button>
              )}
            </>
          }
        />
      ) : (
        <FaxWorkFilters
          rows={viewRows}
          serverCounts={inAll30View ? all30Counts : null}
          providers={faxProviders}
          filters={effectiveFilters}
          onChange={changeWorkFilters}
          available={workAvailable}
          deletedCount={deletedFax.length}
          deletedDays={deletedDays}
          onDeletedDays={(d) => typeof fetchDeletedFax === "function" && fetchDeletedFax(d)}
          staff={staff}
          me={me}
          assignAvailable={assignOn}
        >
          <button
            type="button"
            onClick={() => setIsCollapse(!iscollapse)}
            title={iscollapse ? "Show the list details" : "Narrow list"}
            aria-label={iscollapse ? "Show the list details" : "Narrow list"}
            className="flex h-7 w-7 items-center justify-center rounded-md text-[#667085] hover:bg-[#F2F4F7]"
            data-testid="fax-list-toggle"
          >
            {drag(iscollapse ? "#1D2951" : "#667085")}
          </button>
          {faxProfile.refresh && (
            <button
              type="button"
              onClick={handleRefresh}
              title="Check for new faxes"
              aria-label="Check for new faxes"
              className="flex h-7 w-7 items-center justify-center rounded-md text-[#667085] hover:bg-[#F2F4F7] hover:text-[#1D2951]"
            >
              <RefreshIcon fontSize="small" />
            </button>
          )}
        </FaxWorkFilters>
      )}
      {/* The picks narrowing the list, removable (owner 10-22) */}
      {workAvailable && (
        <FaxActiveFilterChips
          filters={effectiveFilters}
          onChange={changeWorkFilters}
          combine={inboxStyle}
          assignOn={assignOn}
          providers={faxProviders}
          staff={staff}
          large={inboxStyle}
        />
      )}
      {/* Master–Detail Split: fills the screen below the app header (64 px)
          and the two rows, so the PDF starts high and the page itself does not
          scroll (10-13; measured in the harness: top of the split = 156 px,
          24 px of padding below). */}
      <div
        className={
          inboxStyle
            ? "flex w-full min-w-0 flex-col gap-3 md:h-[calc(100vh-205px)] md:min-h-[420px] md:flex-row"
            : "w-full flex gap-3 h-[calc(100vh-180px)] min-h-[420px]"
        }
        data-testid="fax-split"
      >
        {/* LEFT: list (the Inbox: a readable 300-400 px column; full width above the viewer on a phone) */}
         <div
           className={
             inboxStyle
               ? "flex max-h-[60vh] w-full min-h-0 shrink-0 flex-col md:max-h-none md:w-[300px] lg:w-[340px] xl:w-[380px] 2xl:w-[400px]"
               : `w-full ${iscollapse?"sm:w-[18%]":"sm:w-[38%]"} flex min-h-0 flex-col`
           }
           data-testid="fax-list-column"
         >
          {bulkOn && picked.size > 0 ? (
            <div
              className="flex flex-wrap items-center gap-2 rounded-md border border-[#1D2951]/30 bg-[#1D2951]/[0.05] px-2 py-1 text-xs text-[#1D2951]"
              data-testid="fax-bulk-bar"
            >
              <span className="font-semibold">{picked.size} selected</span>
              <label className="sr-only" htmlFor="fax-bulk-assign">
                Assign to
              </label>
              <select
                id="fax-bulk-assign"
                value=""
                disabled={bulkSaving}
                onChange={(e) => bulkAssign(e.target.value)}
                className="h-7 rounded-md border border-[#D0D5DD] bg-white px-1.5 text-xs"
                data-testid="fax-bulk-assign"
              >
                <option value="">Assign to…</option>
                {staff.map((u) => (
                  <option key={u.user_id} value={String(u.user_id)}>
                    {u.name}
                  </option>
                ))}
                <option value="none">Nobody (unassign)</option>
              </select>
              <button
                type="button"
                disabled={bulkSaving}
                onClick={requestBulkDelete}
                className="h-7 rounded-md border border-[#FDA29B] bg-white px-2 text-xs text-[#B42318]"
                data-testid="fax-bulk-delete"
              >
                Delete
              </button>
              <button type="button" className="ml-auto underline" onClick={() => setPicked(new Set())}>
                Clear
              </button>
            </div>
          ) : (
            (!iscollapse || inboxStyle) && (
              <div className={`flex items-center justify-between px-2 py-1 text-[#667085] ${inboxStyle ? "text-[13px]" : "text-xs"}`}>
                <div className="flex items-center gap-2">
                  {bulkOn && paginatedData.length > 0 && (
                    <input
                      type="checkbox"
                      aria-label="Select the faxes on this page"
                      checked={paginatedData.every((r) => picked.has(r.id))}
                      onChange={(e) =>
                        setPicked(e.target.checked ? new Set(paginatedData.map((r) => r.id)) : new Set())
                      }
                      data-testid="fax-pick-page"
                    />
                  )}
                  <span>Total: {shown.length}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <span>Per page</span>
                  <select
                    value={itemsPerPage}
                    onChange={handlePerPageChange}
                    className="h-6 rounded-md border px-1 text-[#1d2951]"
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                  </select>
                </div>
              </div>
            )
          )}

          <div className="flex-1 min-h-0 overflow-y-auto pr-1">
            {loading ? (
              <div className="w-full py-10 text-center text-gray-500">
                Loading...
              </div>
            ) : paginatedData.length === 0 ? (
              <div className="w-full py-10 text-center text-gray-500">
                No Data Available
              </div>
            ) : (
              <ul className="space-y-1.5">
                {paginatedData.map((faxItem, idx) => {
                  const isActive = selectedFaxId === faxItem.id;
                  if (inboxStyle) {
                    return (
                      <InboxFaxListItem
                        key={faxItem.id}
                        row={faxItem}
                        index={(currentPage - 1) * itemsPerPage + idx + 1}
                        active={isActive}
                        ownNames={ownNames}
                        providers={faxProviders}
                        staff={staff}
                        workAvailable={workAvailable}
                        bulkOn={bulkOn}
                        picked={picked.has(faxItem.id)}
                        onPick={() => togglePick(faxItem.id)}
                        onSelect={() => selectFax(faxItem)}
                        menuOpen={openMenuId === faxItem.id}
                        onMenu={() => setOpenMenuId(openMenuId === faxItem.id ? null : faxItem.id)}
                        menuRef={menuRef}
                        onView={() => documentUrl && window.open(documentUrl, "_blank")}
                        onDelete={() => requestDelete(faxItem)}
                        onDeleteAsSpam={() => handleDeleteAsSpam(faxItem)}
                      />
                    );
                  }
                  // Who sent it (faxAi.js faxSource, 10-08): the AI's sender,
                  // else a real caller-ID name, else the number.
                  const src = faxSource(faxItem, ownNames);
                  return (
                    <li
                      key={faxItem.id}
                      className={`rounded-[10px] border border-[#E5E7EB] hover:bg-[#F8FAFC] transition-all cursor-pointer ${
                        isActive
                          ? "!bg-[#50869A] text-white shadow-md"
                          : "bg-white"
                      }`}
                      onClick={() => selectFax(faxItem)}
                    >
                      <div className="flex items-start gap-2.5 p-2">
                        {bulkOn ? (
                          <input
                            type="checkbox"
                            className="mt-0.5"
                            aria-label={`Select fax ${(currentPage - 1) * itemsPerPage + idx + 1}`}
                            checked={picked.has(faxItem.id)}
                            onClick={(e) => e.stopPropagation()}
                            onChange={() => togglePick(faxItem.id)}
                            data-testid="fax-pick"
                          />
                        ) : (
                          <div
                            className={`flex text-sm font-medium font-inter ${
                              isActive ? "text-white" : "text-black"
                            }`}
                          >
                            {(currentPage - 1) * itemsPerPage + idx + 1}
                          </div>
                        )}

                        <div className="flex-1 min-w-0">
                          <div className="flex flex-col items-start justify-start gap-1">
                            <div
                              className={`w-full truncate text-start font-semibold font-inter text-xs ${
                                isActive ? "text-[#FFFFFF]" : "text-[#232323]"
                              }`}
                              title={src.heading}
                              data-testid="fax-row-heading"
                            >
                              {src.heading}
                            </div>
                            <div className="flex justify-between w-full">


                                               <div
                              className={`truncate font-inter text-[10px] font-normal ${
                                isActive ? "text-[#FFFFFFCC]" : "text-[#7E7E7E]"
                              }`}
                            >
                              <span data-testid="fax-row-sub">{src.sub}</span>
                              {src.callerHint && (
                                <span className={isActive ? "text-[#FFFFFFAA]" : "text-[#98A2B3]"}> · {src.callerHint}</span>
                              )}
                            </div>
                            {iscollapse && (
  <div className="relative">
    {/* 3 clickable dots */}
    <div
      className="flex items-center gap-[3px] cursor-pointer"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenuId(openMenuId === faxItem.id ? null :faxItem.id);
      }}
    >
      <div className={`w-[6px] h-[6px] ${isActive ? 'bg-white' : 'bg-[#7E7E7E]'} rounded-full`} />
      <div className={`w-[6px] h-[6px] ${isActive ? 'bg-white' : 'bg-[#7E7E7E]'} rounded-full`} />
      <div className={`w-[6px] h-[6px] ${isActive ? 'bg-white' : 'bg-[#7E7E7E]'} rounded-full`} />
    </div>
{openMenuId === faxItem.id && (
  <div
    ref={menuRef}
    className="absolute right-0 top-5 text-start bg-white border shadow-md rounded-md text-xs z-50 w-[100px]"
    onClick={(e) => e.stopPropagation()}
  >
    <div
      className="px-3 py-2 text-[#232323] hover:bg-gray-100 cursor-pointer"
      onClick={(e) => {
                              e.stopPropagation();
                              if (documentUrl) window.open(documentUrl, "_blank");
                            }}
    >
      View
    </div>

    {!faxIsDeleted(faxItem) && (
    <div
      className="px-3 py-2 text-red-600 hover:bg-gray-100 cursor-pointer"
     onClick={(e) => {
                              e.stopPropagation();
                              requestDelete(faxItem);
                            }}
    >
      Delete
    </div>
    )}
  </div>
)}

  </div>
)}    
                            </div>

                            {/* AI read: quiet label pill, the summary under it (faxAiParts.jsx) */}
                            <FaxAiListLine row={faxItem} active={isActive} />
                            {/* Work: for whom, Done / Review, the latest note (faxWorkParts.jsx) */}
                            {workAvailable && (
                              <FaxWorkListLine row={faxItem} providers={faxProviders} staff={staff} active={isActive} />
                            )}
                            {/* "Likely spam" + one-click Delete as spam (never automatic) */}
                            {!faxIsDeleted(faxItem) && (
                              <FaxJunkLine row={faxItem} active={isActive} onDeleteAsSpam={() => handleDeleteAsSpam(faxItem)} />
                            )}
       
                            {!iscollapse&&<div
                              className={`text-[10px] font-inter font-normal ${
                                isActive ? "text-[#FFFFFFCC]" : "text-[#7E7E7E]"
                              }`}
                            >
                              {dayjs(faxItem.creationTime).format(
                                "MM-DD-YYYY h:mm A"
                              )}
                            </div>}
                          </div>
                        </div>

                       {!iscollapse&& <div className="flex items-center gap-3">
                          {statusChip(faxItem.readStatus, { active: isActive })}
                          <RemoveRedEyeOutlinedIcon
                            fontSize="small"
                            className={`${
                              isActive ? "text-white" : "text-[#6B7280]"
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (documentUrl) window.open(documentUrl, "_blank");
                            }}
                          />
                          {!faxIsDeleted(faxItem) && (
                          <DeleteOutlineIcon
                            fontSize="small"
                            className={`${
                              isActive ? "text-white/80" : "text-[#9CA3AF]"
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              requestDelete(faxItem);
                            }}
                          />
                          )}
                        </div>}
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>

          {/* Pagination (left pane footer) */}
          {shown.length > 0 && (
            <div className="flex items-center justify-between mt-1 px-2 py-1">
              <button
                type="button"
                onClick={handlePrev}
                disabled={currentPage === 1}
                className={`h-7 rounded-md border px-2.5 text-xs ${
                  currentPage === 1
                    ? "cursor-not-allowed border-[#E4E7EC] text-[#98A2B3]"
                    : "border-[#1D2951]/40 text-[#1D2951] hover:bg-[#1D2951]/[0.06]"
                }`}
              >
                Prev
              </button>
              <span className="text-xs text-[#667085]">
                {currentPage} of {totalPages || 1}
              </span>
              <button
                type="button"
                onClick={handleNext}
                disabled={currentPage === totalPages || totalPages === 0}
                className={`h-7 rounded-md border px-2.5 text-xs ${
                  currentPage === totalPages || totalPages === 0
                    ? "cursor-not-allowed border-[#E4E7EC] text-[#98A2B3]"
                    : "border-[#1D2951]/40 text-[#1D2951] hover:bg-[#1D2951]/[0.06]"
                }`}
              >
                Next
              </button>
            </div>
          )}
        </div>

        {/* RIGHT: detail view. Compact header (owner 10-13): one action row
            (‹ › · sender · label · actions), one grey line (number · line ·
            possible patient), the summary clamped to two lines, the work row;
            the PDF fills the rest. */}
        <div
          className={`flex min-h-0 min-w-0 flex-1 flex-col bg-white ${inboxStyle ? "min-h-[70vh] md:min-h-0" : ""}`}
          data-testid="fax-viewer"
        >
          <div className={`flex min-w-0 items-center gap-2 px-3 pb-1 pt-0.5 ${inboxStyle ? "flex-wrap" : ""}`} data-testid="fax-viewer-header">
            <div className="flex shrink-0 items-center overflow-hidden rounded-md border border-[#D0D5DD] divide-x divide-[#E4E7EC]">
              <button
                type="button"
                onClick={handleRowPrev}
                disabled={currentPage === 0 || !selectedFax}
                aria-label="Previous"
                title="Previous fax"
                className={`h-7 px-2 text-[13px] text-[#1D2951] hover:bg-[#F8FAFC] ${
                  currentPage === 1 ? "cursor-not-allowed" : ""
                }`}
              >
                ‹ Previous
              </button>
              <button
                type="button"
                onClick={handleRowNext}
                disabled={currentPage > totalPages}
                aria-label="Next"
                title="Next fax"
                className={`h-7 px-2 text-[13px] text-[#1D2951] hover:bg-[#F8FAFC] ${
                  currentPage >= totalPages ? "cursor-not-allowed" : ""
                }`}
              >
                Next ›
              </button>
            </div>
            {/* Who sent it: the AI's sender in bold with its label pill (10-08) */}
            <div className="min-w-0 flex-1">{selectedFax && <FaxSourceHeader row={viewedFax} compact />}</div>
            <div className={`flex items-center gap-1.5 ${inboxStyle ? "ml-auto flex-wrap justify-end" : "shrink-0"}`}>
              {/* Only for users without Send to EMR: Send to EMR's own "Send to
                  Athena" box files in Athena (10-08). */}
              {selectedFax && !viewedDeleted && showAthenaButton && (
                <button
                  type="button"
                  onClick={() => setAthenaModal(true)}
                  className="h-7 rounded-md border border-[#1D2951] px-2.5 text-[13px] font-medium text-[#1D2951] hover:bg-[#1D2951]/[0.06]"
                >
                  Send to Athena
                </button>
              )}
              {selectedFax && !viewedDeleted && showEmr && (
                <button
                  type="button"
                  onClick={() => setEmrModal(true)}
                  className="h-7 rounded-md border border-[#1D2951] px-2.5 text-[13px] font-medium text-[#1D2951] hover:bg-[#1D2951]/[0.06]"
                >
                  Send to EMR
                </button>
              )}
              {selectedFax && viewedJunk && (
                <button
                  type="button"
                  onClick={() => handleDeleteAsSpam(viewedFax)}
                  title={`${viewedJunk.text}: delete it now (logged as spam; it can be restored under Deleted)`}
                  className="h-7 rounded-md border border-[#F79009] px-2.5 text-[13px] text-[#B54708]"
                  data-testid="fax-delete-spam-viewer"
                >
                  Delete as spam
                </button>
              )}
              {!viewedDeleted && (
                <button
                  type="button"
                  onClick={() => requestDelete(viewedFax || selectedFax)}
                  className="h-7 rounded-md border border-[#FDA29B] px-2.5 text-[13px] text-[#B42318]"
                >
                  Delete Fax
                </button>
              )}
            </div>
          </div>

          {/* The number (or "Source not identified yet"), the line it came in
              on (profile.showLine) and "Possibly: <name> · <DOB>": one grey line */}
          {selectedFax && (
            <div className="flex min-w-0 flex-wrap items-center gap-x-2 px-3 text-start text-xs text-[#7E7E7E]">
              <FaxSourceSubLine row={viewedFax} />
              {faxProfile.showLine && faxLine(selectedFax.extensionId) && (
                <span data-testid="fax-received-on">
                  · Received on {faxLine(selectedFax.extensionId).label} {faxLine(selectedFax.extensionId).number}
                </span>
              )}
            </div>
          )}

          {/* No filing button for this user: say why (owner 10-16) */}
          {selectedFax && !viewedDeleted && filingHint && (
            <div className="px-3 text-start text-xs text-[#7E7E7E]" data-testid="fax-filing-hint">
              {filingHint}
            </div>
          )}

          {/* AI read: the summary (two lines, all of it one click away), "Needs:",
              "Possibly: <name> · <DOB>" (a link, never filed) or "Summarizing..." */}
          {selectedFax && <FaxAiViewerLine row={viewedFax} compact />}

          {/* Work: provider, assignee, Mark done / note / review, history (faxWorkParts.jsx) */}
          {selectedFax && (
            <FaxWorkPanel
              row={viewedFax}
              providers={faxProviders}
              available={workAvailable}
              suggestedPatientId={
                viewedFax?.ai?.match_status === "unique" ? viewedFax.ai.suggested_patientid ?? null : null
              }
              request={workRequest}
              onSaved={reloadLists}
              staff={staff}
              assignAvailable={assignOn}
              canAssign={canAssign}
            />
          )}

          {/* body: the PDF takes the rest of the height */}
          {/* Our viewer (FaxPdfViewer.jsx), not the browser's: its toolbar sits
              above the pages and fits the pane, Print and Download always shown
              (staff 10-22: the browser's toolbar ran past a narrow pane). */}
          <div className="flex min-h-[320px] min-w-0 flex-1 flex-col px-3 pb-1 pt-1.5">
            <div className={`min-h-0 min-w-0 flex-1 rounded-lg bg-[#F3F4F6] ${selectedFax && !documentError ? "overflow-hidden" : "overflow-auto p-1.5"}`}>
              {selectedFax ? (
                documentError ? (
                  <div className="h-full w-full flex items-center justify-center text-[#98A2B3]">
                    {documentError}
                  </div>
                ) : (
                  <FaxPdfViewer
                    url={documentUrl}
                    fileName={`fax-${selectedFax.faxid ?? selectedFax.id ?? "document"}.pdf`}
                  />
                )
              ) : (
                <div className="h-full w-full flex items-center justify-center text-[#98A2B3]">
                  Select a fax from the list to view details.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Loading Spinner for detail fetch */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
  {/* A fresh modal for each open (keyed by the fax), like Send to Athena: no
      patient, files or type carried over from the previous fax. Its "Send to
      Athena" box (off by default) needs the same privilege as the button. */}
  {showEmr && (
  <SendToEmrDocument
             key={emrModal ? `emr:${selectedFax?.faxid ?? selectedFax?.id ?? ""}` : "emr:closed"}
             setsubview={()=>{
              console.log('done')
             }}
  open={emrModal}
selectedFax={selectedFax}
  aiRow={viewedFax}
  canSendToAthena={canSendToAthena}
  onFiled={(info) => handleFiled(selectedFax, info)}
  onClose={() => setEmrModal(false)}
/>
  )}
  {/* A fresh modal for each open (keyed by the fax), so it starts from this
      fax's AI read: the label picks the class, a unique match the patient
      (pre-selected only; staff change them, and only Upload sends). */}
  {showAthenaButton && (
  <SendToAthena
             key={athenaModal ? `athena:${selectedFax?.faxid ?? selectedFax?.id ?? ""}` : "athena:closed"}
              // data={data}
             setsubview={()=>{
              console.log('done')
             }}
  open={athenaModal}
selectedFax={selectedFax}
  aiRow={viewedFax}
  // the viewer's PDF (already loaded): the page thumbnails draw from it
  documentUrl={documentUrl || null}
  onFiled={(info) => handleFiled(selectedFax, info)}
  onClose={() => setAthenaModal(false)}
/>
  )}
      {/* "Mark Done instead?" before deleting a fax that is not spam (owner 10-22) */}
      {doneNudge && (
        <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="fax-done-nudge">
          <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => !nudgeSaving && setDoneNudge(null)}></div>
          <div className="relative mx-4 w-full max-w-md rounded-lg bg-white p-6 text-start shadow-xl" role="dialog" aria-modal="true" aria-labelledby="fax-done-nudge-title">
            <h2 id="fax-done-nudge-title" className="mb-2 text-lg font-semibold text-gray-900">
              Done keeps it findable — Mark Done instead?
            </h2>
            <p className="text-sm text-gray-600">
              {doneNudge.items.length > 1
                ? `${doneNudge.items.length} faxes selected. A done fax stays under Done with its provider; a deleted one only shows under Deleted.`
                : "A done fax stays under Done with its provider; a deleted one only shows under Deleted."}
            </p>
            {doneNudge.items.length > 1 && (
              <div className="mt-3 flex flex-wrap gap-1.5" role="group" aria-label="What happened">
                {FAX_DONE_PICKS.map((p) => (
                  <button
                    key={p}
                    type="button"
                    aria-pressed={nudgePick === p}
                    onClick={() => setNudgePick(nudgePick === p ? "" : p)}
                    className={`whitespace-nowrap rounded-full border px-2.5 py-[2px] text-[12px] font-medium ${
                      nudgePick === p ? "border-[#1D2951] bg-[#1D2951] text-white" : "border-[#D0D5DD] bg-white text-[#344054]"
                    }`}
                    data-testid={`fax-nudge-pick-${p}`}
                  >
                    {p}
                  </button>
                ))}
              </div>
            )}
            <div className="mt-5 flex justify-end gap-3">
              <button
                type="button"
                onClick={nudgeDeleteAnyway}
                disabled={nudgeSaving}
                className="rounded-md bg-gray-100 px-4 py-2 text-sm font-medium text-[#B42318] hover:bg-gray-200"
                data-testid="fax-nudge-delete"
              >
                Delete anyway
              </button>
              <button
                type="button"
                onClick={nudgeMarkDone}
                disabled={nudgeSaving || (doneNudge.items.length > 1 && !nudgePick)}
                title={doneNudge.items.length > 1 && !nudgePick ? "Pick what happened first" : undefined}
                className="rounded-md bg-[#1D2951] px-4 py-2 text-sm font-medium text-white hover:bg-[#1D2951]/90 disabled:opacity-50"
                data-testid="fax-nudge-done"
                autoFocus
              >
                Mark Done
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Delete Confirmation Modal */}
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 ${
          deleteModalOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50"
          onClick={closeDeleteModal}
        ></div>

        {/* Modal Content */}
        <div className="relative bg-white text-start rounded-lg shadow-xl w-full max-w-md mx-4 p-6">
          {/* Dialog Title */}
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Confirm Delete
          </h2>

          {/* Dialog Content */}
          <div className="mb-6">
            <p className="text-gray-600">
              {bulkDelete && bulkDelete.length
                ? `Delete ${bulkDelete.length} ${bulkDelete.length === 1 ? "fax" : "faxes"}? They leave the list and are kept under Deleted with who deleted them and why.`
                : workAvailable
                  ? "Delete this fax? It leaves the list and is kept under Deleted with who deleted it and why."
                  : "Are you sure you want to delete this fax? This action cannot be undone."}
            </p>
            {workAvailable && (
              <div className="mt-3 flex flex-wrap gap-1.5" role="group" aria-label="Why delete">
                {FAX_DELETE_REASONS.map((r) => (
                  <button
                    key={r.id}
                    type="button"
                    aria-pressed={deleteReason === r.id}
                    onClick={() => setDeleteReason(deleteReason === r.id ? "" : r.id)}
                    className={`whitespace-nowrap rounded-full border px-2.5 py-[2px] text-[12px] font-medium ${
                      deleteReason === r.id
                        ? "border-[#1D2951] bg-[#1D2951] text-white"
                        : "border-[#D0D5DD] bg-white text-[#344054]"
                    }`}
                    data-testid={`fax-delete-reason-${r.id}`}
                  >
                    {r.label}
                  </button>
                ))}
              </div>
            )}
            {workAvailable && (
              <input
                type="text"
                value={deleteNote}
                maxLength={500}
                onChange={(e) => setDeleteNote(e.target.value)}
                placeholder="Note (optional)"
                aria-label="Note for deleting"
                className="mt-3 w-full rounded-md border px-3 py-2 text-sm"
              />
            )}
          </div>

          {/* Dialog Actions */}
          <div className="flex justify-end gap-3">
            <button
              onClick={closeDeleteModal}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleDelete}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
              autoFocus
            >
              Delete
            </button>
          </div>
        </div>
      </div>

      
                      <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
    </div>
  );
};

export default FaxTable;